import { Navigate, useLocation } from "react-router-dom";

/**
 * `/resource-map` 비-nav 진입점 (ADR 0020 · #8 M4-I13, 결정 1)
 * --------------------------------------------------------------------------
 * 새 최상위 화면·nav 항목·API 경로를 만들지 않습니다. 기존 질의 상태(cluster·
 * res·item·depth·relation·검색·Scope 등)를 **전부 보존**한 채 canonical
 * `tab=map`만 강제해 기존 `/resources`(ResourcesView의 권한 경계) 안으로
 * 대체(replace) 이동합니다. 모르는 값·권한 없음은 ResourcesView의 기존
 * 동작 그대로이고, 목적지가 `/resources`라 리다이렉트 순환이 없습니다.
 */
export const RESOURCE_MAP_ENTRY_PATH = "/resource-map";
export const RESOURCE_MAP_TARGET_PATH = "/resources";

/** 진입 질의를 canonical `tab=map`으로 정규화합니다(다른 키·순서 보존). */
export function canonicalResourceMapSearch(search: string): string {
  const p = new URLSearchParams(search);
  p.delete("tab");
  p.set("tab", "map");
  const s = p.toString();
  return s ? `?${s}` : "";
}

export function ResourceMapEntry() {
  const { search } = useLocation();
  return (
    <Navigate
      to={{ pathname: RESOURCE_MAP_TARGET_PATH, search: canonicalResourceMapSearch(search) }}
      replace
    />
  );
}
